import React, { useState, useRef, useEffect } from "react";

function CustomDropdown({
  dropdownType,
  selectedOption,
  options,
  onOptionChange,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSelect = (option) => {
    onOptionChange(option);
    setIsOpen(false);
  };

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return dropdownType == "version" ? (
    <div className="dropdown__wrapper">
      <button
        className="dropdown__btn align-items-center btn btn-t1 d-inline-flex font_12 gap-2 bg-white"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="line_control_1">
          {selectedOption?.label || options[0].label || "Choose an option"}
        </span>
        <i className={isOpen ? `fas fa-chevron-up` : `fas fa-chevron-down`}></i>
      </button>
      {isOpen && (
        <div
          className="modal__dropdown font_12"
          ref={dropdownRef}
          style={{ maxWidth: 250, minWidth: 192 }}
        >
          <ul className="dropdown__menu">
            {options.map((option) => (
              <li key={option.value} onClick={() => handleSelect(option)}>
                {option.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  ) : (
    <div className="dropdown__wrapper">
      <button
        className="dropdown__btn align-items-center btn btn-t1 d-inline-flex font_12 gap-1 bg-white px-2 lh-sm"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="line_control_1" style={{ width: 20 }}>
          {selectedOption?.label || options[0].label || "Choose an option"}
        </span>
        <i
          className={
            isOpen ? `fas fa-chevron-up pt_1x` : `fas fa-chevron-down pt_1x`
          }
        ></i>
      </button>
      {isOpen && (
        <div
          className="modal__dropdown font_12 top"
          ref={dropdownRef}
          style={{ maxWidth: 130, minWidth: 115 }}
        >
          <ul className="dropdown__menu">
            {options.map((option) => (
              <li
                key={option.value}
                onClick={() => handleSelect(option)}
                className="d-flex gap-1"
              >
                <span
                  className="bg_dash_blue fw_500 p-1 rounded-1 text-center"
                  style={{ minWidth: 27 }}
                >
                  {option.label}
                </span>
                <span className="my-1">{option.value} </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default CustomDropdown;
